import {
  Dialog,
  Typography,
  DialogActions,
  DialogContent,
} from '@mui/material';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import DosenButton from '../../../../../components/ui/Buttons/DosenButton';

interface Props {
  matchesCount: any;
  confirmedCount: any;
  modelConfirmMatch: any;
  handleCloseConfirmMatch: any;
  handelSubmitConfirmMatch: any;
  handleConfirmAll: any;
  loaderFirstPopup: any;
  loaderFirstPopup1: any;
}

const ConfirmationPopup = ({
  matchesCount,
  confirmedCount,
  modelConfirmMatch,
  handleCloseConfirmMatch,
  handelSubmitConfirmMatch,
  handleConfirmAll,
  loaderFirstPopup,
  loaderFirstPopup1
}: Props) => {
  return (
    <Dialog
      open={modelConfirmMatch}
      onClose={handleCloseConfirmMatch}
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: '#1C1C1C',
          backgroundImage: 'none',
          color: '#FDFDFD',
          border: '1px solid #2A2A2A',
          borderRadius: '12px'
        }
      }}
    >
      <CommonModalHeader 
        title={`Confirmation`}
        handleCloseModal={handleCloseConfirmMatch}
      />
      <DialogContent>
        <Typography sx={{ fontSize: 14, lineHeight: '22px', color: '#B6B6B6' }}>
          You have {matchesCount + confirmedCount} match(es) that require confirmation. You can confirm all matches or just this one. Once you confirm all parties will be notified and their mentoring relationship will begin.
          {/* You have {matchesCount + confirmedCount} auto matches that require confirmation to become active. You can confirm them all at once or confirm each match individually. Once you confirm, both parties will be notified of the match and their mentoring relationship will begin. */}
        </Typography>
      </DialogContent>
      <DialogActions>
        <DosenButton
          fullWidth
          tone="basic"
          loading={loaderFirstPopup}
          loadingText="Confirming..."
          onClick={handelSubmitConfirmMatch}
        >
          Confirm This Match
        </DosenButton>

        <DosenButton
          fullWidth
          // color='primary'
          // variant='contained'
          loading={loaderFirstPopup1}
          loadingText="Confirming..."
          onClick={handleConfirmAll}
        >
          Confirm All Matches
        </DosenButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
